import React from 'react';
import './index.scss';

import { inject, observer } from 'mobx-react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import Select from "@material-ui/core/Select";
import MenuItem from '@material-ui/core/MenuItem';
import { FormControl } from '@material-ui/core';

import InputBase from '@material-ui/core/InputBase';

import {toJS} from 'mobx';

const TIMEOUT = 500;
@inject('internal')
@inject('translate')
@observer
export default class CustomTableSimple extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            available: false,
            rabat_level: 0,
            is_representative: false,
            role_id: false,
        }
    }

    componentDidMount() {
        if(this.props.internal.dataForSimpeTable && this.props.internal.dataForSimpeTable.available ) {
            this.setState({
                available: this.props.internal.dataForSimpeTable.available,
                rabat_level: this.props.internal.dataForSimpeTable.rabat_level === null ? 0 : this.props.internal.dataForSimpeTable.rabat_level,
                // is_representative: this.props.internal.dataForSimpeTable.role.id === 5
            })
            if(this.props.internal.dataForSimpeTable.role) {
                this.setState({
                    is_representative: this.props.internal.dataForSimpeTable.role.id === 5,
                    role_id: this.props.internal.dataForSimpeTable.role.id
                })
            }
        }
    }
    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }
    handleChange = index => {
        //this.props.internal.changeAdministratorData(index.target.id, index.target.value)

        this.props.internal.changeDataForSimpeTable(index.target.id, index.target.value)
        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.props.updateClientData()
        }, TIMEOUT)


    }

    handleChangeAvailable = (event) => {
        this.setState({available: event.target.checked})

        this.props.internal.changeDataForSimpeTable("available", event.target.checked)
        this.props.updateClientData()
    }

    changeRabatLevel = (event) => {
        this.props.internal.changeDataForSimpeTable("rabat_level", event.target.value)
        this.setState({rabat_level: event.target.value})
        this.props.updateClientData()
    }

    handleChangeRole = (event) => {
        this.props.internal.changeDataForSimpeTable("role_id", event.target.value)
        this.setState({role_id: event.target.value})
        this.props.setIsRepresentative(event.target.value)
    }

    handleChangeIsRepresentative = (event) => {
        this.setState({is_representative: event.target.value})
        this.props.setIsRepresentative(event.target.value)
    }

    handleChangehandleChangeRole = (event) => {
        this.setState({role_id: event.target.value})
        this.props.setIsRepresentative(event.target.value)
    }

    render() {
        let permissions = toJS(this.props.internal.user.data.permissions)
        const canChangeRole = permissions.administrators && permissions.administrators.role

        return (
            // <div>dassadas</div>
            <Paper className={this.props.className}>
                <Table >
                    <TableBody >
                        {this.props.labels.map((data, index) => {
                            return (
                                <TableRow key={index} index={index}>
                                    <TableCell component="th" >{data.value}</TableCell>
                                    <TableCell>
                                        {data.label === "available" ?
                                            <Switch
                                                disabled={data.disabled || this.props.disableEdit}
                                                checked={this.state.available}
                                                onChange={this.handleChangeAvailable}
                                                value="available"
                                                classes={{
                                                    switchBase: 'switchBase',
                                                    checked: 'checked',
                                                    bar: 'switch-bar'
                                                }}
                                            />
                                            :
                                            data.dropDown ?
                                                toJS(this.props.internal.user.data.permissions.clients) && toJS(this.props.internal.user.data.permissions.clients.update)?
                                                    <Select
                                                        value={this.state.rabat_level}
                                                        onChange={this.changeRabatLevel}
                                                        disableUnderline
                                                        inputProps={{
                                                            name: 'rabat-level',
                                                            id: 'rabat-level',
                                                        }}
                                                        classes={{
                                                            root: 'root-rabat-level',
                                                            select: 'select-rabat-level'
                                                        }}
                                                    >
                                                        <MenuItem value={0}>0%</MenuItem>
                                                        <MenuItem value={1}>30%</MenuItem>
                                                        <MenuItem value={2}>20%</MenuItem>
                                                        <MenuItem value={3}>23%</MenuItem>
                                                        <MenuItem value={4}>25%</MenuItem>
                                                        <MenuItem value={5}>27%</MenuItem>
                                                    </Select>
                                                    :
                                                    <InputBase
                                                        id={data.label}
                                                        className={'input-base'}
                                                        defaultValue={this.props.internal.dataForSimpeTable[data.label]}
                                                        disabled={true}
                                                    />
                                                :
                                                data.label === "is_representative" ?
                                                <FormControl className='tags-selector min-width-200 is_representative'>
                                                    {/* <InputLabel htmlFor="isRepresentative" className={'label-select-tag'}>{this.props.translate.i18n.MODULES.ADMINISTRATORS.ADMIN_ROLE}</InputLabel> */}
                                                    <Select
                                                        // className={'multiple-select '}
                                                        value={this.state.role_id}
                                                        onChange={this.handleChangeRole}
                                                        inputProps={{
                                                            name: 'isRepresentative',
                                                            id: 'isRepresentative',
                                                        }}
                                                        disableUnderline={true}
                                                        disabled={!canChangeRole}
                                                        // renderValue={() => {return(<span>{this.props.internal.dataForSimpeTable.role.id === 2 ? this.props.translate.i18n.MODULES.ADMINISTRATORS.ADMINISTRATOR : this.props.translate.i18n.MODULES.ADMINISTRATORS.ADMIN_REPRESENTATIVE}</span>)}}
                                                    >
                                                        <MenuItem value={2} >{this.props.translate.i18n.MODULES.ADMINISTRATORS.ADMINISTRATOR}</MenuItem>
                                                        <MenuItem value={5} >{this.props.translate.i18n.MODULES.ADMINISTRATORS.ADMIN_REPRESENTATIVE}</MenuItem>
                                                        <MenuItem value={6} >{this.props.translate.i18n.MODULES.PRIVILEGES.WAREHOUSE}</MenuItem>
                                                    </Select>
                                                </FormControl>
                                                :
                                                <InputBase
                                                    id={data.label}
                                                    className={'input-base'}
                                                    //defaultValue={this.props.internal.administrator[data.label]}
                                                    defaultValue={this.props.internal.dataForSimpeTable[data.label]}
                                                    onChange={this.handleChange}
                                                    disabled={data.disabled || this.props.disableEdit}
                                                />
                                        }
                                        {}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/complex/customTableSimple/index.js